import { DOCUMENT } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ConfigService {
  public timeout: number = 60000; // default timeout
  public timeoutErrorMessage: string = 'Timeout Error';
  public loginLastSeenIntervalInSeconds = 35; //default value
  public loginStatisticsEnabled = true; //default value

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private http: HttpClient // Inject HttpClient
  ) {}

  public init() {
    // set apiUrl
    let element = this.document.getElementById(
      'portalAppUrl'
    ) as HTMLInputElement;
    if (element) {
      environment.apiUrl = element.value;
    }
  }

  public loadSettingsFromServer(): Promise<void> {
    if (!environment.apiUrl) {
      console.error('API URL is not set.');
      return Promise.reject('API URL is not set.');
    }
    let cultureCodeElem = <HTMLInputElement>document.getElementById('currentCultureCode');
 let requestParams :any= {cultureCode:cultureCodeElem.value};
 
    return this.http
      .post<{
        apisTimeout: number;
        apisTimeOutMessage: string;
        loginStatisticsEnabled: boolean;
        lastSeenUpdateIntervalInSeconds: number;
      }>(
        `${environment.apiUrl}/umbraco/api/PortalGeneralSettingsApi/GetPortalAppSettings`,requestParams
      )
      .toPromise()
      .then((settings) => {
        if (settings) {
          this.setApisConfig(
            settings.apisTimeout,
            settings.apisTimeOutMessage,
            settings.loginStatisticsEnabled,
            settings.lastSeenUpdateIntervalInSeconds
          );
        } else {
          console.error('Settings are undefined.');
          // Optionally, provide default values or handle the undefined case
          this.setApisConfig(
            60000, // default timeout
            'Timeout Error', // default timeout error message
            true, // default loginStatisticsEnabled
            35 // default lastSeenUpdateIntervalInSeconds
          );
        }
      })
      .catch((error) => {
        console.error('Error loading settings from server:', error);
        // Handle the error as needed, possibly setting default values
        this.setApisConfig(
          60000, // default timeout
          'Timeout Error', // default timeout error message
          true, // default loginStatisticsEnabled
          35 // default lastSeenUpdateIntervalInSeconds
        );
      });
  }

  public setApisConfig(
    timeout: number,
    timeoutErrorMessage: string,
    loginStatisticsEnabled: boolean,
    lastSeenUpdateIntervalInSeconds: number
  ) {
    this.timeout = timeout;
    this.timeoutErrorMessage = timeoutErrorMessage;
    this.loginStatisticsEnabled = loginStatisticsEnabled;
    this.loginLastSeenIntervalInSeconds = lastSeenUpdateIntervalInSeconds;
  }
}
